import React from 'react';
import { Github, Linkedin, Mail, Film } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background">
      <div className="w-full max-w-[1040px] mx-auto px-6 sm:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-3">
            <h3 className="text-lg font-bold tracking-[-0.01em]">{personalInfo.name}</h3>
            <p className="text-sm text-muted-foreground">
              {personalInfo.title}
            </p>
            <p className="text-sm text-muted-foreground">
              {personalInfo.location}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Quick links</h4>
            <nav className="flex flex-col gap-2">
              <a 
                href="/" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--dur-2)] w-fit"
              >
                Home
              </a>
              <a 
                href="/about" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--dur-2)] w-fit"
              >
                About
              </a>
              <a 
                href="/projects" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--dur-2)] w-fit"
              >
                Projects
              </a>
              <a 
                href="/contact" 
                className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--dur-2)] w-fit"
              >
                Contact
              </a>
            </nav>
          </div>

          {/* Connect */}
          <div className="space-y-3">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Connect</h4>
            <div className="flex gap-3">
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-accent hover:border-accent transition-all duration-[var(--dur-2)]"
              >
                <Github className="h-4 w-4" />
              </a>
              <a
                href={personalInfo.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-accent hover:border-accent transition-all duration-[var(--dur-2)]"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              {personalInfo.linktree && (
                <a
                  href={personalInfo.linktree}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Linktree"
                  className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-accent hover:border-accent transition-all duration-[var(--dur-2)]"
                >
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5108 5.85343L17.5158 1.73642L19.8404 4.11701L15.6393 8.12199H21.5488V11.4268H15.6113L19.8404 15.5345L17.5158 17.8684L11.7744 12.099L6.03299 17.8684L3.70842 15.5438L7.93745 11.4361H2V8.12199H7.90944L3.70842 4.11701L6.03299 1.73642L10.038 5.85343V0H13.5108V5.85343ZM10.038 16.16H13.5108V24H10.038V16.16Z"/>
                  </svg>
                </a>
              )}
              {personalInfo.filmReel && personalInfo.filmReel !== '#' && (
                <a
                  href={personalInfo.filmReel}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Film reel"
                  className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-accent hover:border-accent transition-all duration-[var(--dur-2)]"
                >
                  <Film className="h-4 w-4" />
                </a>
              )}
            </div>
            {personalInfo.funFact && (
              <p className="text-xs text-muted-foreground leading-relaxed pt-3">
                {personalInfo.funFact}
              </p>
            )}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            © {currentYear} {personalInfo.name}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
